import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { getCurrencyAmount } from "./../../utils/stringUtils";
import { getInvoiceInformationAsync } from "./../../services/invoiceService";
import _ from "lodash";

const Invoice = () => {
  const { id } = useParams();

  const [data, setData] = useState({});

  useEffect(() => {
    let mounted = true;

    const fetchInvoice = async () => {
      const request = await getInvoiceInformationAsync(id);
      if (request === undefined) window.location = "/404";

      const response = request.data;
      const { result } = response;

      if (mounted) setData(result);
    };

    fetchInvoice();

    return () => {
      mounted = false;
    };
  }, [id]);

  return (
    <div className="mt-5">
      <div className="max-w-7xl mx-auto px-6 lg:px-0">
        <div className="flex justify-between items-center">
          <img
            className="h-7 w-auto"
            src="/medtax-logo.png"
            alt="medtax-logo"
          />
          <p className="text-gray-600 font-semibold uppercase">Invoice</p>
        </div>
        <div className="mt-24">
          <table className="table-fixed">
            <thead>
              <tr>
                <th className="w-1/2"></th>
                <th className="w-1/2"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-gray-600">Client:</td>
                <td className="text-gray-500">
                  Dr. {data.first_name} {data.last_name}
                </td>
              </tr>
              <tr>
                <td className="text-gray-600">Account ID:</td>
                <td className="text-gray-500">{data.account_number}</td>
              </tr>
              <tr>
                <td className="text-gray-600">Billed Address:</td>
                <td className="text-gray-500">{data.address}</td>
              </tr>
              <tr>
                <td className="text-gray-600">Invoice No:</td>
                <td className="text-gray-500">{data.invoice_number}</td>
              </tr>
              <tr>
                <td className="text-gray-600">Invoice Date:</td>
                <td className="text-gray-500">{data.invoice_date}</td>
              </tr>
              <tr>
                <td className="text-gray-600">Period:</td>
                <td className="text-gray-500">{data.period}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-16">
          <div style={{ background: "#7fe3ff" }} className="p-3">
            Services
          </div>
          <table className="table-fixed">
            <thead>
              <tr>
                <td className="w-full"></td>
                <td className="w-full"></td>
              </tr>
            </thead>
            <tbody>
              {!_.isEmpty(data) &&
                data.invoice_items.map((item, index) => (
                  <tr key={index} className="text-gray-500">
                    <td className="px-5 py-1">{item.name}</td>
                    <td className="float-right px-5 py-1">
                      {getCurrencyAmount(item.amount)}
                    </td>
                  </tr>
                ))}
              <tr className="text-gray-500">
                <td className="text-right">Subtotal</td>
                <td className="text-right px-5 py-1">
                  {getCurrencyAmount(data.sub_total)}
                </td>
              </tr>
            </tbody>
          </table>
          {!_.isEmpty(data) && data.unpaid_invoices.length > 0 && (
            <table className="table-fixed">
              <thead>
                <tr>
                  <td className="w-1/3"></td>
                  <td className="w-full"></td>
                  <td className="w-full"></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-10 pb-2 italic">Unpaid Invoices</td>
                </tr>
                {!_.isEmpty(data) &&
                  data.unpaid_invoices.map((item, index) => (
                    <tr key={index} className="text-gray-500">
                      <td className="px-20">{item.invoice_number}</td>
                      <td className="px-20">{item.period}</td>
                      <td className="px-5 float-right">
                        {getCurrencyAmount(item.amount)}
                      </td>
                    </tr>
                  ))}
                <tr className="text-gray-500">
                  <td colSpan={2} className="text-right">
                    Remaining Balance
                  </td>
                  <td className="text-right px-5 py-1">
                    {getCurrencyAmount(data.total_amount - data.sub_total)}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <table className="table-fixed">
            <thead>
              <tr>
                <td className="w-full"></td>
                <td className=""></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-5 font-semibold  text-right">
                  Total Amount Due
                </td>
                <td className="text-right font-semibold px-5">
                  <span className="mr-2">&#8369;</span>
                  {getCurrencyAmount(data.total_amount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
